// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"53":"bbaf4c52","991":"c7ec08f9"}[chunkId] + ".chunk.js");